(() => {
  const getHashTarget = (hash) => {
    if (!hash || hash === '#') return null;

    try {
      return document.getElementById(decodeURIComponent(hash.slice(1)));
    } catch (_error) {
      return null;
    }
  };

  const openTargetedFaq = (hash, behavior = 'smooth') => {
    const target = getHashTarget(hash);
    if (!target) return false;

    const detailsToOpen = [];
    if (target.matches('details')) detailsToOpen.push(target);

    let parentDetails = target.parentElement?.closest('details');
    while (parentDetails) {
      detailsToOpen.push(parentDetails);
      parentDetails = parentDetails.parentElement?.closest('details');
    }

    if (detailsToOpen.length === 0) return false;

    detailsToOpen.reverse().forEach((details) => {
      details.open = true;
    });

    requestAnimationFrame(() => {
      target.scrollIntoView({ behavior, block: 'start' });
    });

    return true;
  };

  document.addEventListener('click', (event) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    const link = event.target.closest('a[href*="#"]');
    if (!link || link.target) return;

    const url = new URL(link.href, window.location.href);
    const isSamePage =
      url.origin === window.location.origin &&
      url.pathname === window.location.pathname &&
      url.search === window.location.search;

    if (!isSamePage || !openTargetedFaq(url.hash)) return;

    event.preventDefault();
    if (window.location.hash !== url.hash) {
      window.history.pushState(null, '', url.hash);
    }
  });

  const openCurrentHash = () => openTargetedFaq(window.location.hash, 'auto');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openCurrentHash, { once: true });
  } else {
    openCurrentHash();
  }

  window.addEventListener('hashchange', openCurrentHash);
})();
